import React, { useState } from 'react'
import { range } from '../../utils/locDash'
import Flex from '../Flex'
import Icon from '../Icon'
import { ProgressRatingProps } from './Progress.types'

const ProgressRating: React.FC<ProgressRatingProps> = ({
  variant = 'outline',
  count = 5,
  value = 0,
  size = 24,
  readOnly = false,
  onChange,
  ...restProps
}) => {
  const [ratingValue, setRatingValue] = useState(value)
  const [hover, setHover] = useState(null)

  const onRatingClicked = (value: number) => {
    setRatingValue(value)
    onChange(value)
  }

  return (
    <Flex alignItems='center' {...restProps}>
      {range(count).map((_, index) => {
        const value = index + 1
        const isActive = value <= (hover || ratingValue)
        return (
          <Icon
            key={`star-${value}`}
            size={size}
            name={isActive ? 'Star-solid' : `Star-${variant}`}
            onMouseEnter={() => !readOnly && setHover(value)}
            onMouseLeave={() => !readOnly && setHover(ratingValue)}
            onClick={() => !readOnly && onRatingClicked(value)}
            cursor={!readOnly ? 'pointer' : 'default'}
            color={isActive ? 'yellow50' : 'black25'}
            aria-label={isActive ? 'active' : 'deactive'}
          />
        )
      })}
    </Flex>
  )
}

export default ProgressRating
